<template>
  <div class="footer">
    <div class="c-footer-start">
      <div class="footer-title">让小企业轻松应用物联网技术提升生产力</div>
      <div class="start-button" @click="gotoReigsterPage">
        <p><strong>即刻启程：提升你的生产力吧</strong></p>
      </div>
      <div class="clear"></div>
    </div>
    <div class="full-container c-footer-container">
      <div class="c-foot-content">
        <div class="cont-detail">
          <div class="cont-detail-qrcode-group left">
            <div class="cont-detail-qrcode left">
              <img class="qrcode-icon" src="../assets/img/home/wei-qrcode.jpg"/>
              <div class="qrcode-desc">微信公众号</div>
            </div>
            <div class="cont-detail-qrcode left">
              <img class="qrcode-icon" src="../assets/img/home/company-qrcode.png"/>
              <div class="qrcode-desc">点度官网</div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="cont-detail-contact right">
            <div class="company-logo">
              <img src="../assets/img/home/logo.png"/>
              <div class="clear"></div>
            </div>
            <div class="company-address">佛山点度物联科技有限公司</div>
            <div class="company-address">diandu_team@163.com</div>
            <div class="company-address">QQ:3538279609</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="cont-record">
          <a class="footer-copy-link" href="http://www.miitbeian.gov.cn"> © 佛山点度物联科技有限公司 版权所有&nbsp;&nbsp;|&nbsp;&nbsp;粤ICP备17107533号</a>
          <img class="footer-police-icon" src="../assets/img/home/police@1x.46004ef.png"/>
        </div>
        <div class="cont-record-for-mobile">
          <a class="footer-copy-link" href="http://www.miitbeian.gov.cn"> © 佛山点度物联科技有限公司 版权所有<br/>粤ICP备17107533号</a>
          <img class="footer-police-icon" src="../assets/img/home/police@1x.46004ef.png"/>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomFooter',
  data () {
    return {
      aboutUs: {
        url: '/about',
        label: '关于我们'
      }
    }
  },
  methods: {
    handleNav (nav) {
      this.$router.push({path: nav.url})
    },
    gotoReigsterPage () {
      // window.open('https://open.dianduiot.com/user.html#/register')
    }
  }
}
</script>

<style scoped lang="scss">
  .c-footer-start {
    width: 100%;
    background: linear-gradient(to right,#c352fa,#4c46bd);
    text-align: center;
    padding-bottom: 50px;
  }
  .footer-title {
    font-size: 36px;
    padding: 40px 0 20px 0;
    color: white;
    margin: 0 15px;
  }
  .start-button {
    height: 50px;
    width: 100%;
    margin: auto;
    background-color: lavender;
    border-radius: 10px 10px 10px 10px;
    max-width: 340px;
    cursor: pointer;
  }
  .start-button p {
    padding-top: 12px;
    white-space: nowrap;
    overflow: hidden;
    font-size: 18px;
  }
  .start-button:hover{
    background-color:#333333;
    color: lavender;
  }
  .c-footer-container {
    width: 100%;
    background-color: #062951;
    text-align: center;
    padding-bottom: 50px;
  }
  a.footer-copy-link, a.footer-copy-link:visited {
    color: #bfbfbf;
    vertical-align: middle;
  }
  a.footer-copy-link:hover {
    color: #fff
  }
  .footer-police-icon {
    display: inline;
    margin-left: 10px;
    vertical-align: middle;
  }
  .c-foot-content {
    width: 100%;
    max-width: 1130px;
    padding: 0 15px;
    box-sizing: border-box;
    margin: auto;
  }
  .cont-detail {
    padding-top: 40px;
    margin-bottom: 20px;
  }
  .cont-detail-qrcode {
    margin-right: 20px;
  }
  .qrcode-icon {
    width: 120px;
    height: auto;
    border-radius: 8px;
  }
  .qrcode-desc {
    width: 120px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
  }
  .company-logo {
    text-align: right;
    margin-bottom: 2px;
  }
  .company-logo img{
    width: 50px;
    float: right;
  }
  .company-address {
    text-align: right;
    color: #ffffff;
    line-height: 20px;
  }
  .cont-record-for-mobile {
    display: none;
  }
  .read-more:hover {
    color: #fff;
  }
  @media all and (max-width: 1430px) {
    .c-foot-content {
      padding: 0 65px;
    }
  }
  @media all and (max-width: 750px) {
    .footer-title {
      font-size: 18px;
    }
    .start-button p {
      font-size: 16px;
    }
    .c-foot-content {
      padding: 0 15px;
    }
  }
  @media all and (max-width: 520px) {
    .cont-detail-qrcode-group {
      width: 100%;
    }
    .cont-detail-qrcode {
      width: 50%;
      margin-right: 0;
    }
    .qrcode-icon {
      margin: auto;
    }
    .qrcode-desc {
      width: 100%;
    }
    .company-logo {
      display: none;
    }
    .company-address {
      text-align: center;
    }
    .cont-detail-contact {
      width: 100%;
      margin-top: 40px;
    }
    .cont-record {
      display: none;
    }
    .cont-record-for-mobile {
      display: block;
      margin-top: 30px;
    }
  }
  @media all and (max-width: 350px) {
    .start-button {
      width: 90%;
      height: 40px;
    }
    .start-button p{
      padding-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BottomFooter.vue